"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _TransitionHeight = require("../../TransitionHeight");
require("./ScreenPrompt.less");
var _components = require("../../../components");
var _utils = require("../../../utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var Screen = function Screen(_ref) {
  var height = _ref.height,
    onClose = _ref.onClose,
    children = _ref.children;
  var _useCssMedia = (0, _utils.useCssMedia)(),
    md = _useCssMedia.md;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "--tag-cubby-screen h-full overflow-y-auto flex flex-col"
  }, onClose && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('flex-shrink-0 flex justify-end pr-[16px] pt-[16px] pb-[24px]', 'md:justify-start md:pt-[40px] md:pr-0 md:pl-[24px]')
  }, /*#__PURE__*/_react.default.createElement(_components.IconButton, {
    className: !md && height === _TransitionHeight.TransitionHeightMode.Auto ? 'hidden' : '',
    icon: md ? 'close-24' : 'close-16',
    size: md ? 'large' : 'small',
    onClick: onClose
  })), children);
};
var _default = Screen;
exports.default = _default;